<template>
  <div class="flex flex-wrap complete-menu">
    <!-- flex flex-column-->
    <MenuItem v-for="(item, itemIndex) in items" :key="itemIndex" :icon="item.icon" :text="item.reference" :path-name="item.pathName" :path="item.path" />
  </div>
</template>

<script>
import { computed } from 'vue';
import { useStore } from 'vuex';
import MenuItem from '@/components/menu/MenuItem';

import { menuHandler } from '@/mixins/utils';

export default {
  components: { MenuItem },
  props: {
    sessionsCount: {
      type: Number,
      default: 0
    }
  },
  setup (props) {
    const store = useStore();

    const items = computed(() => {
      let menu = menuHandler('Home');
      const tabsToRemove = [];
      const hasSpeedboatContext = !!store.state.user.contexts.find(a => a.value === 'speedboat');

      if (!hasSpeedboatContext) {
        tabsToRemove.push('Services');
      }

      // Hide Planning tab if sessionsCount is 0 or less
      if (props.sessionsCount <= 0) {
        tabsToRemove.push('Planning');
      }

      if (tabsToRemove.length > 0) {
        menu = menu.filter(m => !tabsToRemove.includes(m.pathName));
      }

      return menu;
    });

    return { items };
  }
};
</script>

<style>
.complete-menu {
  padding: 0rem 2rem; /*px3*/
}

@media (min-width: 52em) {
  .complete-menu {
    padding: 0rem 0rem;
    margin: 0rem 0rem;
  }
}

</style>
